import { I18n } from 'src/translations/i18n';
export var TranslationActionTypes;
(function (TranslationActionTypes) {
    TranslationActionTypes["TRANSLATION_SET_LANG"] = "TRANSLATION_SET_LANG";
})(TranslationActionTypes || (TranslationActionTypes = {}));
export function setAppLang(lang) {
    return async (dispatch) => {
        await I18n.setLocale(lang);
        return dispatch({ type: TranslationActionTypes.TRANSLATION_SET_LANG, payload: lang });
    };
}
export function setInitialAppLang(langPreference) {
    return async (dispatch) => {
        const lang = await I18n.init(langPreference);
        return dispatch({ type: TranslationActionTypes.TRANSLATION_SET_LANG, payload: lang });
    };
}
